import React, { Component } from 'react';
import {Howl, Howler} from 'howler';

import './SwirleVideo.css';
import './transitions.css';

import { initRequestAnimFrame, getGesturePointFromEvent, isInside } from './Tools'

const _RATIO_END_S = 0.9;  //   Ratio à atteindre sur la video pour terminer ex. 0.9 x 2s (2s = durée vidéo)
const _DELAY_MIN_TO_SEEK_S = 33;    // en ms, delay entre deux seek    
const _ANGLE_LIMIT_DEP_S = 60; // angle max entre deux step (touchmove) ou on ne considère pas l'évent (cas d'erreurs de valeurs)
const _SPEED_ROTATE_S = 4.0;  // multiplicateur de vitesse pour la rotation du swirle

class SwirleVideo extends Component {

    constructor(props) {

        super(props);       
        

        this.handleGestureStart = this.handleGestureStartFn.bind(this);
        this.handleGestureEnd = this.handleGestureEndFn.bind(this);
        this.handleGestureMove = this.handleGestureMoveFn.bind(this);             
        
        this.startDrag = false;
        this.lastTouchPos = null;

        this.video = false;

        this.divTouch = null;
        this.setdivTouch = element => {
            this.divTouch = element;
        };            
        this.setPlayer = element => {
            this.video = element;
        };            
        this.loop_sound = false;
        this.sound_playing = false;

        this._last_angle = false;
        this._current_angle = 0;
    }

    componentDidMount() 
    {
        initRequestAnimFrame();      
                 
        this.video.src = this.props.video;
        this.video.loop = false;  // pour éviter les bugs avec set_video_loop()
        this.video.load();             
        //this.video.play(); //

        
        // Add Touch Listener
        this.divTouch.addEventListener('touchstart', this.handleGestureStart, true);
        this.divTouch.addEventListener('touchmove', this.handleGestureMove, true);
        this.divTouch.addEventListener('touchend', this.handleGestureEnd, true);
        this.divTouch.addEventListener('touchcancel', this.handleGestureEnd, true);

        // Add Mouse Listener
        this.divTouch.addEventListener('mousedown', this.handleGestureStart, true);
        
        this.startDrag = false;
        this.touchStart = false;        

        this._last_angle = false;

        /* launch sound */

        this.loop_sound = new Howl({
            src: './videos/CH02/18/C18.mp3',
            /*autoplay: true,*/
            loop: true,
          });            
        
    }    


    componentWillUnmount()
    {
        // Remove Touch Listener
        this.divTouch.removeEventListener('touchstart', this.handleGestureStart);
        this.divTouch.removeEventListener('touchmove', this.handleGestureMove);
        this.divTouch.removeEventListener('touchend', this.handleGestureEnd);
        this.divTouch.removeEventListener('touchcancel', this.handleGestureEnd);

        // Remove Mouse Listener
        this.divTouch.removeEventListener('mousedown', this.handleGestureStart);
        
        if(this.loop_sound)
        {
            this.loop_sound.unload();
            this.loop_sound = false;
        }
        

    }
        
    
    componentDidUpdate(prevProps, prevState, snapshot)
    {

        if( prevProps.menuOpen !== this.props.menuOpen)
        {
            if(this.props.menuOpen)
            {
                if(this.loop_sound) this.loop_sound.pause();
            }else
            {
                if(this.loop_sound) this.loop_sound.play();            
            }
        }
    }
/*
    shouldComponentUpdate(nextProps, nextState)
    {
        // ne doit pas refaire de render, sinon le canvas sera detruit 
        return false;
    }
*/

/* ----------------------------------------------- */

    set_events( endp)
    {
        if(!this.video) return;
    
        this.video.addEventListener("error", (e) => {
            let msg="";
            switch (e.target.error.code) {
            case e.target.error.MEDIA_ERR_ABORTED:
                msg = 'You aborted the video playback.';
                break;
            case e.target.error.MEDIA_ERR_NETWORK:
                msg = 'A network error caused the video download to fail part-way.';
                break;
            case e.target.error.MEDIA_ERR_DECODE:
                msg = 'The video playback was aborted due to a corruption problem or because the video used features your browser did not support.';
                break;
            case e.target.error.MEDIA_ERR_SRC_NOT_SUPPORTED:
                msg = 'The video could not be loaded, either because the server or network failed or because the format is not supported.';
                break;
            default:
                msg = 'An unknown error occurred.';
                break;
            }
            this.props.logFn("DragVideo:set_events !!!!! FAILED error (video)::"+msg);      
        });
    
        this.video.addEventListener("ended", (e) => { 
            //this.props.logFn("DragVideo::set_events:ended event >>>> ");         
            if(endp) endp(e);
        });

    }

/* ----------------------------------------------- */

    // Handle the start of gestures
    handleGestureStartFn(evt) {
        evt.preventDefault();

        this.props.logFn("SwirleVideo:handleGestureStartFn()");

        if(evt.touches && evt.touches.length > 1)   return;
    
        // Add the move and end listeners
        if(this.divTouch){
            this.divTouch.addEventListener('mousemove',this.handleGestureMove, true);
            this.divTouch.addEventListener('mouseup', this.handleGestureEnd, true);
        }
    
        this.startDrag = true;

        this.delay = Date.now();        
        
    };

    // Handle end gestures
    handleGestureEndFn(evt) {
        evt.preventDefault();

        this.props.logFn("SwirleVideo:handleGestureEndFn()");

        if(evt.touches && evt.touches.length > 0)   return;
    
        // Remove Event Listeners
        if(this.divTouch){
            // Remove Mouse Listeners
            this.divTouch.removeEventListener('mousemove', this.handleGestureMove, true);
            this.divTouch.removeEventListener('mouseup', this.handleGestureEnd, true);
        }
    
        this.startDrag = false;
        this._last_angle = null;
    }

    handleGestureMoveFn(evt) {
        evt.preventDefault();

        this.props.logFn('SwipeHandler:handleGestureMoveFn()', this.startDrag);
      
        if(!this.startDrag)  return;
      
        // important pour avoir un seek sans lag
        
        let delay0 = Date.now();
        if( (delay0 - this.delay)  < _DELAY_MIN_TO_SEEK_S) return;   // si -40ms entre deux touch, pas de seek
        this.delay = delay0;

        const p = getGesturePointFromEvent(evt);    

        const pz = this.divTouch.getBoundingClientRect();

        //console.log(p, pz);

        if(isInside( p, pz) )
        {     
            const a = this.get_angle(p);

            if(this._last_angle != false)
            {
                let da = a - this._last_angle;

                if( da > _ANGLE_LIMIT_DEP_S ) 
                {
                    this._last_angle = a;
                    return;  // pour éviter les erreurs (touch horizontal qui déclanche des gros angles)
                }                
                if( da > 0)  // que des angles positif : sans des aiguilles d'une montre                 
                { 
                    // pour minimer l'angle plus on s'approche du centre : est-ce utile ?
                    var px = p.x - this.divTouch.clientWidth / 2;
                    var py = p.y - this.divTouch.clientHeight / 2;
                    var dt = Math.sqrt( px*px + py*py ) / Math.sqrt(this.divTouch.clientWidth * this.divTouch.clientWidth + this.divTouch.clientHeight * this.divTouch.clientHeight);  
                    da *= dt * _SPEED_ROTATE_S;  
                    //da *= _SPEED_ROTATE_S;  

                    //console.log(da, this._current_angle);

                    this._current_angle += da;

                    if( (this._current_angle / 360 > 0.33 ) && !this.sound_playing )
                    {
                        this.sound_playing = true;
                        this.loop_sound.play();
                    }
                    const d = this.video.duration;
                    let t = this._current_angle / 360 * d;                

                    if( t < 0 && (this.video.readyState >= 2) ) this.video.currentTime = 0;
                    else if( (t > 0) && (t < this.video.duration) && (this.video.readyState >= 2) )   // pour éviter les seek en cascade                     
                    {
                        window.requestAnimFrame( ()=> {
                            this.video.currentTime = t;
                        });                        
                    }

                    // Calcul la sortie de la video */
                    if( t >= d * _RATIO_END_S){

                        this.startDrag = false;
                        this._last_angle = null;                        
                        
                        this.props.onEnd();
                    }
                    
                }
            }
            this._last_angle = a;        
        }
    }

    get_angle = (p) =>
    {
        var x = p.x - this.divTouch.clientWidth/2; 
        var y = p.y - this.divTouch.clientHeight/2; 
        var angle = Math.atan2(y,x) * 180.0 / Math.PI;
        if(y<0) angle += 360
        return angle;
    }


    render() {

        const { touchZone } = this.props;

        let style = { top: 0, left:0, width: '100%', height: '100%'};

        if(touchZone)
        {                        
            style.left =    touchZone.x+'%';
            style.top =     touchZone.y+'%';
            style.width =   touchZone.w+'%';
            style.height =  touchZone.h+'%';
        }

        let cl = 'videoTouchZoneSwirle';
        if(window._DEBUG_TOUCH) cl += ' debugTouch ';

        return( <div className="SwirleVideo" >    
                    <video className="videoSwirle" ref={ this.setPlayer } playsInline="playsInline" preload="auto"></video>
                    <div className={ cl } style={ style } ref={ this.setdivTouch }>
                        { this.props.children }
                    </div>                    
               </div>);


  }
  
}



//----------------------------------------------------------------------------

export default SwirleVideo;



// WEBPACK FOOTER //
// ./src/SwirleVideo.js